import styled from "styled-components";

import chatButtonShadow from "../../../../assets/chat_button_shadow.png";

export const ChatControlButtonContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-image: url(${chatButtonShadow});
  background-size: 90% 90%;
  background-position: center 0.3125rem;
`;
